// Percentage threshold of missing data required to trigger estimation.
export const ESTIMATION_MISSING_DATA_FRACTION_THRESHOLD = 0.25

export interface ProgressEstimationResult {
  criteriaMet: boolean
  estimatedTotal: number
  estimatedCompleted: number
}

export function computeProgressEstimation(
  totalsWithData: number[],
  completedSum: number,
  countWithoutData: number,
  threshold: number = ESTIMATION_MISSING_DATA_FRACTION_THRESHOLD,
): ProgressEstimationResult {
  const totalCount = totalsWithData.length + countWithoutData
  const missingFraction = totalCount > 0 ? countWithoutData / totalCount : 0
  const criteriaMet =
    totalsWithData.length >= 1 &&
    countWithoutData >= 1 &&
    missingFraction >= threshold

  const averageTotal =
    totalsWithData.length > 0
      ? totalsWithData.reduce((a, b) => a + b, 0) / totalsWithData.length
      : 0
  const estimatedTotal =
    totalsWithData.reduce((a, b) => a + b, 0) + averageTotal * countWithoutData

  return {
    criteriaMet,
    estimatedTotal: Math.round(estimatedTotal),
    estimatedCompleted: Math.round(completedSum),
  }
}
